import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const Redirect = () => {
  const navigate = useNavigate()

  useEffect(() => {
    navigate('/registration?regulation=reg-a&step=email')
  }, [])

  return <></>
}

export default Redirect
